import { deleteBrand } from 'api/brand/api';
import Loader from 'components/Loader';
import { Modal } from 'components/Modal/Modal';
import { GraniteButton } from 'components/V2/Button/GraniteButton';
import { useModal } from 'hooks/useModal';
import { FC } from 'react';
import { useMutation } from 'react-query';

export interface RestoreProps {
  brandId?: string;
  onRestoreSuccess: () => void;
}
const Restore: FC<RestoreProps> = ({ brandId, onRestoreSuccess }) => {
  const { isOpen, close, open } = useModal();

  const { mutate, isLoading } = useMutation(deleteBrand, {
    onSuccess: () => {
      onRestoreSuccess();
      close();
    },
  });

  const onRestore = () => {
    if (brandId) mutate(brandId);
    else {
      onRestoreSuccess();
      close();
    }
  };

  return (
    <>
      <Modal isVisible={isOpen} close={close} className="w-full max-w-[624px]">
        <div className="p-8">
          <div>
            <h1 className="text-2xl font-bold text-content-base-default">
              Are you sure you want to restore defaults?
            </h1>
            <p className="mt-2 text-base font-bold text-content-base-subdued">
              This will reset all branding settings to their default values.
              Your current customizations will be lost and cannot be undone.
            </p>
          </div>
          <div className="mt-8 flex gap-5">
            <GraniteButton variant="secondary" size="large" onClick={close}>
              Cancel
            </GraniteButton>
            <GraniteButton
              size="large"
              variant="destructive"
              disabled={isLoading}
              onClick={onRestore}
            >
              Yes, restore defaults
              {isLoading ? <Loader width="w-5" height="h-5" /> : null}
            </GraniteButton>
          </div>
        </div>
      </Modal>
      <GraniteButton
        variant="ghost"
        className="w-max"
        size="small"
        onClick={open}
        disabled={isLoading}
      >
        Restore default
      </GraniteButton>
    </>
  );
};

export default Restore;
